<template>
    <!-- 这个是显示全部的 -->
    <!-- <van-pull-refresh v-model="isLoading" @refresh="getChooseFeeList"> -->
        <div class="choose-fee-more-container">
			<fee-card :showTitle="false" :listArr="chooseFeeList"></fee-card>
        </div>
    <!-- </van-pull-refresh> -->

</template>

<script>
    import apiChooseFee from "api/anonymous-pay"
    import log from "utils/log"
	// import {getState, setState} from "utils/state"
	import storage from 'good-storage'
	import feeCard from "components/fee-card/index";
    import utils from '@/utils/util'
    import { removeToken} from '@/utils/cache'

    export default {
		name:'chooseFeeMore',
        components: {
			feeCard
		},

        data() {
            return {
                chooseFeeList: [],
                // isLoading: false,
            }
		},
		
        created() {
            // this.firstLoading = true
            removeToken()
            this.getChooseFeeList()
		},
		
        methods: {
            getChooseFeeList() {
                // this.isLoading = true
                apiChooseFee.list().then(res => {
					let d = res.data || []
                    const self = this
                    if (utils.isNotEmpty(d)) {
						this.chooseFeeList = d.map(x => {
							return {
								name: x.itemName,
                                src: x.src,
                                origin: x,
                                onClick: (item) => self.clickItem(item),
                            }
                        })
                    }
					// this.isLoading = false

                    // this.$nextTick(() => {
                    //     this.isLoading = false
                    //     this.firstLoading = false
                    // })
                })
			},
			
            clickItem(item) {
                log('item', item)
				// setState('select-item', item.origin)
				storage.session.set('select-item',item.origin)
                this.$router.push({
                    name: 'anonymous-pay-detail',
                })
            },
		},

    }
</script>

<style lang='scss' scoped>
</style>
